import { render, staticRenderFns } from "./SysPositionModal.vue?vue&type=template&id=52e47815&scoped=true&"
import script from "./SysPositionModal.vue?vue&type=script&lang=js&"
export * from "./SysPositionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e47815",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e47815')) {
      api.createRecord('52e47815', component.options)
    } else {
      api.reload('52e47815', component.options)
    }
    module.hot.accept("./SysPositionModal.vue?vue&type=template&id=52e47815&scoped=true&", function () {
      api.rerender('52e47815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysPositionModal.vue"
export default component.exports